export default __webpack_public_path__ + "locales/sl/ChangeUserStatusDialog.json?hash=24ad8bf6ab0250c0bd4b9f2e135171ba";